<template>
	<div>
		<PageHeaderLayout :isBack="true">
			<div class="main-page-content">
				<el-card shadow="never">
					<el-form label-width="110px" class="detail-form">
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="项目名称">
									<el-input :value="detail.title || '-'" disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="公司名称">
									<el-input :value="detail.company_name || '-'" disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="负责人">
									<el-input :value="detail.leader_user_name || '-'" disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="工作地点">
									<el-input :value="detail.address_detail || '-'" disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="计划开始时间">
									<el-input :value="detail.start_date || '-'" disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="计划结束时间">
									<el-input :value="detail.end_date || '-'" disabled></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="项目介绍">
							<div class="remark" v-html="detail.remark || '-'"></div>
						</el-form-item>
					</el-form>
				</el-card>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
	name: 'JobManageDetails',
	components: {
		PageHeaderLayout
	},
	data() {
		return {
			detail: {}
		}
	},
	methods: {
		async init() {
			const id = this.$route.query.id
			if (!id) return
			try {
				const res = await this.$api.getHrProjectDetail(id)
				this.detail = res || {}
			} catch (e) {
				this.detail = {}
				this.$message.error(e.message || '获取详情失败')
			}
		}
	},
	mounted() {
		this.init()
	}
}
</script>

<style scoped lang="scss">
.remark {
	min-height: 120px;
	padding: 8px 12px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	line-height: 26px;
	/deep/ img {
		max-width: 100%;
	}
}
</style>
